import { getCampaignUser as getAPICampaignUser } from "../../lib/apiLoader/campaign";
import { setCampaignUser, campaignUserStore } from "../stores/campaignUser";
import type { CampaignUser } from "../../types/campaign";
import { get } from "svelte/store";

export const getCampaignUser = async (options: { refresh: boolean } | undefined = { refresh: false }) => {
  if (options.refresh || !get(campaignUserStore).hasLoaded) {
    const campaignUser = await getAPICampaignUser();
    setCampaignUser(campaignUser.campaign_user);
  }

  return get(campaignUserStore).campaignUser as CampaignUser;
};
